<template>
  <div class="pages">
    <!-- 导航 -->
    <shortcut></shortcut>
    <!-- 导航 -->

    <!-- 头部 -->
    <commonHeader :selectCode="1"></commonHeader>
    <!-- 头部 -->
    <div class="content">
      <img src="/static/img/Snipaste_2022-06-25_15-06-08.png"
           alt=""
           style="height:90px">

      <div class="h">
        <div class="right"
             v-if="changci.length > 0">
          <div class="item pointer"
               :class="currentIndex == index ? 'cur' : ''"
               v-for="(item,index) in changci"
               :key="item.id"
               @click="tabClick(item.id,t(item,index)),currentIndex=index">
            <span v-if="t(item,index) != 2">{{item.changci}}</span>
            <span class="btn"
                  v-if="t(item,index) == 3">{{$t('即将开始')}}</span>
            <span class="btn"
                  v-if="t(item,index) == 1"
                  style="border: none;">{{$t('已经结束')}}</span>

            <div class="t"
                 v-if="t(item,index) == 2"> <span>{{item.changci}}</span> {{$t('正在秒杀')}}</div>
            <div v-if="t(item,index) == 2"
                 class="s">{{$t('距离结束')}} {{ hou}}:{{min}}:{{sec}}</div>
          </div>
        </div>
      </div>

      <el-empty description=" "
                image="/static/kong.png"
                :image-size="550"
                v-if="dataList.length==0">
        <el-button type="primary"
                   @click="goQQ()"
                   style="width: 90px;height: 60px;margin-left: -10px;margin-top: 20px;">{{$t('按钮')}}</el-button>
      </el-empty>

      <div class="list"
           v-else>
        <div class="item"
             v-for="(item,index) in dataList"
             :key="index">
          <div class="img"><img :src="$jx.oss(item.image)"
                 alt=""></div>
          <div class="info">
            <span class="title ellipsis">{{item.title}}</span>
            <span class="desc ellipsis">{{item.description}}</span>
            <div class="pross">
              <div class="current"><span :style="{width: item.sales/item.stock_num * 100}"></span></div>
              <div class="num">{{$t('已售')}}{{Number(item.sales/item.stock_num * 100).toFixed(2)}}%</div>
            </div>
            <div class="button">
              <div class="money">
                <div>￥<span>{{Number(item.price).toFixed(2)}}</span> </div>
                <div>￥{{Number(item.market_price).toFixed(2)}}</div>
              </div>
              <!-- #e6e6e6 -->
              <div class="b"
                   @click="item.acIndex!=2?'':goPage(item)"
                   :class="item.acIndex!=2?'acIndexColor':''">{{item.acIndex==1?$t('已结束'):item.acIndex==3?'未开始':$t('立即抢购')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <foot></foot>

  </div>
</template>

<script>
import shortcut from '@/components/shortcut/shortcut.vue';
import carousel from '@/components/carousel/carousel.vue';
import seckill from '@/components/seckill/seckill.vue';
import foot from '@/components/footer/footer.vue';
// import swiper from '@/components/swiper/swiper.vue';
export default {

  components: {
    shortcut,
    carousel,
    seckill,
    foot
    // swiper
  },
  data () {
    return {
      changci: [],
      dataList: [],
      currentIndex: null,
      dataForm: {},
      hou: '00',
      min: '00',
      sec: '00',
      interval: null
    }
  },
  mounted () {
    this.getchangci()

  },
  computed: {

  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
  methods: {
    // qq
    goQQ () {
      let common = JSON.parse(localStorage.getItem('jx:common')).data
      window.open(`http://wpa.qq.com/msgrd?v=1&uin=${common.web_qq}&site=qq&menu=yes`)
    },
    goPage (data) {
      data = JSON.stringify({ id: data.id, miao: true })
      let routeData = this.$router.resolve({
        path: `/main/goods/${data}`,
        query: data
      })
      window.open(routeData.href, '_blank')
    },
    time (endTime) {
      var that = this
      that.interval = setInterval(function timestampToTime () {
        var date = endTime - parseInt(new Date().getTime() / 1000);
        //new Date当前的时间戳，也可以换成自定义的时间戳
        if (date > 0) {
          let time = date;
          // 获取时、分、秒,毫秒
          that.hou = parseInt((time % (60 * 60 * 24)) / 3600) < 10 ? ('0' + parseInt((time % (60 * 60 * 24)) / 3600)) : parseInt((time % (60 * 60 * 24)) / 3600)
          that.min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60) < 10 ? ('0' + parseInt(((time % (60 * 60 * 24)) % 3600) / 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
          that.sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60) < 10 ? ('0' + parseInt(((time % (60 * 60 * 24)) % 3600) % 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
        } else {
          clearInterval(that.interval);
          return false
        }
      }, 1000)
    },
    t (item, index) {
      let changci = this.changci
      var myDate = new Date(); //实例一个时间对象；
      myDate.getHours(); //获取系统时，
      let b = myDate.getHours();
      let a = Number(item.changci.split(':')[0]);
      let c = 20;
      if (changci.length - 1 > index) {
        c = Number(changci[index + 1].changci.split(':')[0]);
      }
      if ((c <= b && c != 0)) {
        return 1 //结束
      }
      if (a <= b && (c > b || c == 0)) {
        return 2 //正在开始
      }
      if (a > b) {
        return 3 //即将开始
      }
    },
    tabClick (id, acIndex) {
      this.$http.post("/wanlshop/Activity/getgoodslist", { changci_id: id }).then(res => {
        if (res.code == 1) {
          let goods = res.data.goods
          goods.forEach(item => {
            item.acIndex = acIndex
          });
          this.dataList = goods
        }
      })
    },
    currentTime () {
      var myDate = new Date(); //实例一个时间对象；
      myDate.getHours(); //获取系统时
      return myDate.getHours()
    },
    getchangci () {
      this.$http.get("/wanlshop/Activity/getchangci", {}).then(res => {
        if (res.code == 1) {
          this.changci = res.data
        }
      })
      this.$http.get("/wanlshop/Activity/getnewchangci", {}).then(res => {
        if (res.code == 1) {
          this.dataForm = res.data
          this.time(res.data.activity.endtime)
          this.currentIndex = res.data.id - 1
          this.tabClick(res.data.id, this.t(res.data))
        }
      })
    },
  },
};

</script>
<style scoped lang="scss">
/deep/ .el-empty__bottom {
  position: absolute;
  opacity: 0;
}
.pages {
  background-color: #f4f4f4;

  .header {
    padding-top: 20px;
    background-color: #fff;

    .block {
      max-width: 1200px;
      min-width: 1200px;
      height: 120px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .logo {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 100px;

        img {
          width: 80px;
        }

        .cl {
          color: #fff;
          background-color: #0094e7;
          line-height: 36px;
          /* width: 190px; */
          padding: 0 15px;
          font-size: 14px;
          box-sizing: border-box;
          margin-top: 10px;
          font-weight: 600;
        }
      }

      .center {
        display: flex;
        /* flex-direction: column; */
        /* justify-content: space-between; */
        align-items: center;
        height: 100%;
        flex: 1;
        overflow: hidden;

        .top {
          width: 100%;
          box-sizing: border-box;
          padding: 0 30px;

          .search {
            display: flex;
            /* justify-content: flex-end; */

            .blocks {
              display: flex;
              flex-direction: column;

              .hot {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .item {
                  color: #999999;
                  font-size: 12px;
                  margin: 0 4px;

                  &.cur {
                    color: #0094e7;
                  }
                }
              }

              .inputs {
                width: 600px;
                border: 2px solid #0094e7;
                height: 32px;
                display: flex;
                justify-content: space-between;
                margin-right: 20px;
                margin-bottom: 10px;

                select {
                  border: none;
                  outline: none;
                  color: #0094e7;
                  padding: 0 8px;
                  border-right: 1px solid #0094e7;
                }

                input {
                  flex: 1;
                  border: none;
                  outline: none;
                  position: relative;
                  padding: 0 10px;
                  font-size: 14px;
                }

                .ss {
                  width: 50px;
                  background-color: #0094e7;
                  box-sizing: border-box;
                }
              }
            }

            .cart {
              height: 32px;
              line-height: 32px;
              color: #0094e7;
              font-size: 12px;
              border: 1px solid #dddddd;
              padding: 0 30px;
            }
          }
        }
      }
    }
  }

  .content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-width: 1200px;
    max-width: 1200px;
    margin: 0 auto;

    .h {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background-color: #fff;

      .left {
        background: linear-gradient(83deg, #fd5845, #f81c4c);
        color: #fff;
        padding: 4px 20px;

        .t {
          font-size: 18px;
          font-weight: bold;

          span {
            font-size: 24px;
          }
        }

        .s {
          font-size: 12px;
        }
      }

      .right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex: 1;

        .item {
          color: #000;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          padding: 4px 0;

          &.cur {
            background: linear-gradient(83deg, #fd5845, #f81c4c);
            color: #fff;
            /* padding: 4px 20px; */

            .t {
              font-size: 18px;
              font-weight: bold;

              span {
                font-size: 24px;
              }
            }

            .s {
              font-size: 12px;
            }

            .btn {
              color: #fff;
              border-color: #fff;
            }
          }

          .btn {
            color: #666666;
            font-size: 12px;
            border: 1px solid #666666;
            border-radius: 100px;
            padding: 2px 10px;
            margin-top: 2px;
          }
        }
      }
    }

    .list {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-bottom: 20px;

      .item {
        width: calc((100% - 30px) / 4);
        margin-top: 10px;
        background-color: #fff;
        margin-right: 10px;
        padding: 0 20px 14px 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;

        &:nth-child(4n) {
          margin-right: 0;
        }

        > .img img {
          display: inline-block;
          height: 200px;
        }

        .info {
          width: 100%;
          /* display: flex;
            flex-direction: column; */

          .title {
            color: #333333;
            font-size: 13px;
            width: 250px;
            display: inline-block;
          }

          .desc {
            color: #df0021;
            font-size: 13px;
            width: 250px;
            display: inline-block;
            margin-top: 4px;
          }

          .pross {
            margin: 20px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .num {
              font-size: 13px;
              color: #666666;
              margin-left: 10px;
            }

            .current {
              background-color: #e6e6e6;
              height: 10px;
              border-radius: 10px;
              overflow: hidden;
              position: relative;
              flex: 1;

              span {
                display: inline-block;
                position: absolute;
                left: 0;
                top: 0;
                background-color: #df0021;
                height: 30px;
              }
            }
          }

          .button {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .b {
              font-size: 16px;
              color: #fff;
              padding: 10px 20px;
              background: linear-gradient(83deg, #fd5845, #f81c4c);
              cursor: pointer;
            }
            .acIndexColor {
              background: #e6e6e6;
            }

            .money {
              display: flex;
              justify-content: flex-start;
              align-items: baseline;

              div {
                &:first-child {
                  color: #e01222;
                  font-size: 14px;

                  span {
                    font-size: 24px;
                  }
                }

                &:last-child {
                  color: #888888;
                  font-size: 13px;

                  text-decoration: line-through;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/seckill/seckill.vue